/*
 * contact-form.js — Contacto y soporte lightbox.
 *
 * Posts each field as its own multipart part to FormBold. There is no
 * server hop.
 */

(function () {
  var TEXT_FIELDS = ['tema', 'nombre', 'email', 'mensaje'];
  var HASH = '#contact-form';

  function trim(value) {
    return value ? String(value).trim() : '';
  }

  function normalizeText(value) {
    return trim(value).replace(/\s+/g, ' ').toLowerCase();
  }

  function isContactOpener(anchor) {
    if (!anchor || anchor.tagName !== 'A') return false;
    var href = (anchor.getAttribute('href') || '').toLowerCase();
    if (href.indexOf('contact-form') !== -1) return true;
    if (href.indexOf('contacto-y-soporte') !== -1) return true;
    return normalizeText(anchor.textContent) === 'contacto y soporte';
  }

  function closeHeaderDrawer() {
    var drawer = document.querySelector('[data-header-drawer]');
    if (!drawer || !drawer.open) return;
    var closeBtn = document.querySelector('[data-header-drawer-close]');
    if (closeBtn) closeBtn.click();
  }

  function initContactForm(root) {
    var form = root.querySelector('[data-contact-form-fields]');
    var title = root.querySelector('[data-contact-form-title]');
    var landing = root.querySelector('[data-view-landing]');
    var success = root.querySelector('[data-view-success]');
    var error = root.querySelector('[data-view-error]');
    var submit = root.querySelector('[data-submit]');
    var consent = root.querySelector('[data-consent]');
    var openForm = root.querySelector('[data-open-form]');
    var selectRoot = root.querySelector('[data-select]');
    var selectTrigger = root.querySelector('[data-select-trigger]');
    var selectList = root.querySelector('[data-select-list]');
    var selectValue = root.querySelector('[data-select-value]');
    var selectInput = root.querySelector('[data-select-input]');
    var selectField = root.querySelector('[data-select-field]');
    var emailEl = root.querySelector('[data-success-email]');

    if (!form || !landing) return;

    var endpoint = root.dataset.endpoint;
    var titleLanding = root.dataset.titleLanding || '';
    var titleForm = root.dataset.titleForm || '';

    function showView(name) {
      landing.hidden = name !== 'landing';
      form.hidden = name !== 'form';
      success.hidden = name !== 'success';
      error.hidden = name !== 'error';
      if (title) title.textContent = name === 'landing' ? titleLanding : titleForm;
    }

    function formComplete() {
      return (
        trim(form.elements.tema && form.elements.tema.value) &&
        trim(form.elements.nombre && form.elements.nombre.value) &&
        trim(form.elements.email && form.elements.email.value) &&
        form.elements.email.checkValidity() &&
        trim(form.elements.mensaje && form.elements.mensaje.value) &&
        consent &&
        consent.checked
      );
    }

    function setSubmit() {
      if (submit) submit.disabled = !formComplete();
    }

    function closeSelect() {
      if (!selectList) return;
      selectList.hidden = true;
      if (selectField) selectField.classList.remove('is-open');
    }

    function setTopic(label) {
      if (selectInput) selectInput.value = label || '';
      if (selectValue) selectValue.textContent = label || '';
      closeSelect();
      setSubmit();
    }

    function open() {
      closeHeaderDrawer();
      showView('landing');
      root.hidden = false;
      document.body.classList.add('is-contact-form-open');
      if (history.replaceState && window.location.hash !== HASH) {
        history.replaceState(null, '', window.location.pathname + window.location.search + HASH);
      }
      var closeBtn = root.querySelector('.contact-form__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.hidden = true;
      document.body.classList.remove('is-contact-form-open');
      closeSelect();
      if (window.location.hash === HASH) {
        if (history.replaceState) history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    function reset(keepOpen) {
      form.reset();
      setTopic('');
      setSubmit();
      showView('landing');
      if (!keepOpen) close();
    }

    form.addEventListener('input', setSubmit);
    form.addEventListener('change', setSubmit);

    if (openForm) {
      openForm.addEventListener('click', function () {
        showView('form');
      });
    }

    if (selectTrigger) {
      selectTrigger.addEventListener('click', function () {
        if (!selectList) return;
        var openList = selectList.hidden;
        selectList.hidden = !openList;
        if (selectField) selectField.classList.toggle('is-open', openList);
      });
    }

    if (selectList) {
      selectList.addEventListener('click', function (event) {
        var option = event.target.closest('[data-select-option]');
        if (!option) return;
        setTopic(trim(option.textContent));
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!formComplete()) return;

      var payload = new FormData();
      TEXT_FIELDS.forEach(function (name) {
        var field = form.elements[name];
        var value = field ? trim(field.value) : '';
        if (value) payload.append(name, value);
      });

      submit.disabled = true;
      submit.textContent = root.dataset.labelSending;
      if (emailEl) emailEl.textContent = trim(form.elements.email.value);

      fetch(endpoint, { method: 'POST', body: payload })
        .then(function (response) {
          showView(response.ok ? 'success' : 'error');
        })
        .catch(function () {
          showView('error');
        })
        .then(function () {
          submit.disabled = false;
          submit.textContent = root.dataset.labelSubmit;
          setSubmit();
        });
    });

    root.querySelectorAll('[data-reset]').forEach(function (button) {
      button.addEventListener('click', function () {
        showView('form');
      });
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('a');
      if (opener && isContactOpener(opener) && !root.contains(opener)) {
        event.preventDefault();
        open();
        return;
      }
      if (selectList && !selectList.hidden && selectRoot && !selectRoot.contains(event.target)) {
        closeSelect();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (root.hidden) return;
      if (event.key !== 'Escape') return;
      event.preventDefault();
      if (selectList && !selectList.hidden) {
        closeSelect();
        return;
      }
      close();
    });

    root.querySelectorAll('[data-contact-form-dismiss]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!success.hidden || !error.hidden) reset(false);
        else close();
      });
    });

    setSubmit();
    showView('landing');

    if (window.location.hash === HASH) open();
  }

  function start() {
    document.querySelectorAll('[data-contact-form]').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
